module.exports = __webpack_public_path__ + "img/option_icon.cfc1c2a3.svg";